<template>
  <div id="app">
   <progressloading ref="loadingcomp" v-bind:mesaj="$t('Your-process-progress')" v-bind:iconname="'edit'" v-model="progressloading"></progressloading>

    <v-card color="grey lighten-5" flat>

      <v-container fluid="">
        <v-container fluid="">
          <v-form ref="formsalesreport" v-model="valid" lazy-validation>

            <v-layout align-center="" fill-height="" row wrap="">

              <v-flex xs12 sm6 md2> 
                <tarihcomp :etiket="$t('Starting-Date')"  v-bind:defaultvalue="'ok'"
                  v-bind:value="SummaryInfo.BaslangicTarihi" :rules="[v => !!v || $t('Please-select-a-date')]"
                  v-model="SummaryInfo.BaslangicTarihi"></tarihcomp>
              </v-flex>

              <v-flex xs12 sm6 md2>
                <tarihcomp :etiket="$t('Finishing-Date')" :rules="[v => !!v || $t('Please-select-a-date')]"
                  v-bind:value="SummaryInfo.BitisTarihi" v-bind:defaultvalue="'ok'" v-model="SummaryInfo.BitisTarihi">
                </tarihcomp>
              </v-flex>
              <!-- <v-btn color="info" @click="silelim()" small="" dark>
                    deneyelim
                    </v-btn> -->
              <v-flex>
                <v-layout align-center justify-start row fill-height>

                  <v-btn v-show="load1" color="info" @click="getList()" fab small="" dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                  <v-progress-circular v-show="!load1" indeterminate color="info"></v-progress-circular>

                  <v-tooltip bottom="" :activator="el" v-model="tooltip">
                    <span>{{$t('Add-Search-Filter')}}</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-form>

        </v-container>


        <v-layout row wrap v-if="PB=='TRY'">

          <v-flex xs12 sm6 md3 style="padding-right:2px;" >
            <v-card color="#1E88E5" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">trending_up</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>

                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Sales')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{satis}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Refund')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{iade}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">{{ $t('Void') }}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">: {{voidbilet}} </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-card-title>

                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                 {{$t('totalnumber')}}
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>


          <v-flex xs12 sm6 md3 style="padding-right:2px;">
            <v-card color="#4CAF50" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">queue</v-icon>
                  </v-layout>
                </v-flex>


                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Sales')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{toplamsatis}}{{getparabirimi()}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>


                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Refund')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{toplamiade}}{{getparabirimi()}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm3 md3>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">{{$t('Earning')}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm9 md9>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-bold caption  white--text  mb-1">:
                                {{toplamkazanc}} {{getparabirimi()}}
                                <!-- {{toplamservis}} -->
                              </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                {{$t('Total')}}
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md3 style="padding-right:2px;" >
            <v-card color="#FF6F00" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">poll</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>


                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm8 md8>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Hard-Copy-Invoice')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{kagitfatura}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm8 md8>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('E-archive-Sent-Not-Sent')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{earsivgonderilen}}/{{earsivgonderilmeyen}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm8 md8>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-medium caption  white--text title mb-1"> 
                              {{$t('E-invoice-Sent-Not-Sent')}}
                              </div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              <div class="font-weight-medium caption  white--text title mb-1"> :
                                {{efaturagonderilen}}/{{efaturagonderilmeyen}}</div>
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-card-title>


                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                {{$t('Number-of-Invoices-by-Type')}}
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>



          <v-flex xs12 sm6 md3 style="padding-right:2px;">
            <v-card color="#FF5252" class="white--text">
              <v-layout>
                <v-flex xs2 sm2 md2>
                  <v-layout align-center="" justify-center="" fill-height="">
                    <v-icon color="white" large="">insert_drive_file</v-icon>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm10 md10>
                  <v-card-title primary-title="">
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                             {{$t('Invoiced')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{faturaedilmisbilet}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{$t('Uninvoiced')}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{faturaedilmemisbilet}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-layout>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              {{ $t('Temporarily-Pending') }}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-list-tile-title>
                            <span class="caption font-weight-bold">
                              : {{gecicibilet}}
                            </span>
                          </v-list-tile-title>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                  </v-card-title>
                </v-flex>
              </v-layout>
              <v-divider light></v-divider>
              <v-card-actions class="pa-3">
                {{ $t('Number-of-Invoices-Tickets') }}
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-flex>

        </v-layout>

        <v-layout row wrap v-if="PB!='TRY'">

<v-flex xs12 sm6 md4 style="padding-right:2px;" >
  <v-card color="#1E88E5" class="white--text">
    <v-layout>
      <v-flex xs2 sm2 md2>
        <v-layout align-center="" justify-center="" fill-height="">
          <v-icon color="white" large="">trending_up</v-icon>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md10>

        <v-card-title primary-title="">
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{$t('Sales')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{satis}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{$t('Refund')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{iade}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    <div class="font-weight-bold caption  white--text  mb-1">{{ $t('Void') }}</div>
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    <div class="font-weight-bold caption  white--text  mb-1">: {{voidbilet}} </div>
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-card-title>

      </v-flex>
    </v-layout>
    <v-divider light></v-divider>
    <v-card-actions class="pa-3">
       {{$t('totalnumber')}}
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-flex>


<v-flex xs12 sm6 md4 style="padding-right:2px;">
  <v-card color="#4CAF50" class="white--text">
    <v-layout>
      <v-flex xs2 sm2 md2>
        <v-layout align-center="" justify-center="" fill-height="">
          <v-icon color="white" large="">queue</v-icon>
        </v-layout>
      </v-flex>


      <v-flex xs12 sm10 md10>
        <v-card-title primary-title="">


          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{$t('Sales')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{toplamsatis}}{{getparabirimi()}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>


          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{$t('Refund')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{toplamiade}}{{getparabirimi()}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm3 md3>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    <div class="font-weight-bold caption  white--text  mb-1">{{$t('Earning')}}</div>
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm9 md9>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    <div class="font-weight-bold caption  white--text  mb-1">:
                      {{toplamkazanc}} {{getparabirimi()}}
                      <!-- {{toplamservis}} -->
                    </div>
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
      </v-flex>
    </v-layout>
    <v-divider light></v-divider>
    <v-card-actions class="pa-3">
      {{$t('Total')}}
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-flex>





<v-flex xs12 sm6 md4 style="padding-right:2px;">
  <v-card color="#FF5252" class="white--text">
    <v-layout>
      <v-flex xs2 sm2 md2>
        <v-layout align-center="" justify-center="" fill-height="">
          <v-icon color="white" large="">insert_drive_file</v-icon>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm10 md10>
        <v-card-title primary-title="">
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                   {{this.$t('Invoiced')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{faturaedilmisbilet}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{this.$t('Uninvoiced')}}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{faturaedilmemisbilet}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-layout>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    {{ $t('Temporarily-Pending') }}
                  </span>
                </v-list-tile-title>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-list-tile-title>
                  <span class="caption font-weight-bold">
                    : {{gecicibilet}}
                  </span>
                </v-list-tile-title>
              </v-flex>
            </v-layout>
          </v-flex>

        </v-card-title>
      </v-flex>
    </v-layout>
    <v-divider light></v-divider>
    <v-card-actions class="pa-3">
      {{ $t('Number-of-Invoices-Tickets') }}
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</v-flex>

</v-layout>

      </v-container>
      <v-container fluid="">

        <v-layout row wrap>

          <v-flex pa-1 xs12 sm12 md12>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-container fluid="">
                    <v-card flat>

                      <p class="text-md-center font-weight-bold headline text-black ">{{$t('bysale')}}</p>

                      <div id="app">

                        <ve-line :loading="loading1" :judge-width="true" :data="chartsatistipinegore"></ve-line>
                      </div>
                    </v-card>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>


          <v-flex pa-1 xs12 sm12 md6>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-container fluid="">
                    <v-card flat>
                      <p class="text-md-center font-weight-bold headline text-black ">{{$t('accordingtoairlines')}}</p>
                      <ve-histogram :colors="colors" :loading="loading1" :judge-width="true" :settings="chartSettings"
                        :data="charthavayolunagore"></ve-histogram>
                    </v-card>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>

          <v-flex pa-1 xs12 sm12 md6>
            <v-card class="white--text">
              <v-card color="grey lighten-4" flat="">
                <v-card-actions>
                  <v-container fluid="">


                    <v-card flat>
                      <p class="text-md-center font-weight-bold headline text-black ">
                        {{$t('accordingtotheshapeofsale')}}</p>


                      <ve-pie :loading="loading1" :data="chartsatisseklinegore"></ve-pie>
                    </v-card>
                  </v-container>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>





        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'

  import VeLine from 'v-charts/lib/line.common'
  import VeBar from 'v-charts/lib/bar.common'
  import VePie from 'v-charts/lib/pie.common'
  import VeHistogram from 'v-charts/lib/histogram.common'
  import tarihcomp from '../customcomp/tarihim'
  import tool from "../coper/tools";
  import helpers from "@/components/app/customcomp/helpers.js"
  import progressloading from "@/components/app/customcomp/progressloading"

  export default {
    data() {
      return {

        PB:"TRY",
        progressloading:false,


        SummaryInfo: {

          FormNo: null,
          BiletNo: null,
          SirketKodu: null,
          CariKod: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          Havayolu: null,

        },

        loading1: true,
        load1: true,
        satis: 0,
        iade: 0,
        voidbilet: 0,
        toplamsatis: 0,
        toplamiade: 0,
        toplamservis: 0,
        toplamkazanc:0,
        toplamborc: 0,
        vadesigelenborc: 0,
        faturaedilmisbilet: 0,
        faturaedilmemisbilet: 0,
        gecicibilet: 0,

        kagitfatura: 0,
        earsivgonderilen: 0,
        earsivgonderilmeyen: 0,
        efaturagonderilen: 0,
        efaturagonderilmeyen: 0,

        chartSettings: {
          title: {
            show: true,
            text: 'eaieaei'
          },
          label: {
            show: true
          },
          axisSite: {
            right: ['growthRate']
          },
          yAxisType: ['KMB'],
          yAxisName: ['Adet']
        },
        drawer: null,

        currentDebtTotal: 0,
        currentCreditTotal: 58,
        debtTotal: 0,
        creditTotal: 0,
        valid: true,
        tooltip: false,
        el: null,
        charthavayolunagore: {
          rows: [],
          columns: ['firma', 'satis', 'iade'],
        },

        chartsatistipinegore: {
          columns: ['tarih', this.$t('Number-of-Domestic-Flight-Sales'), this.$t('Number-of-Domestic-Flight-Refunds'), this.$t('Number-of-International-Flight-Sales'), this.$t('Number-of-International-Flight-Refunds')],
          rows: []
        },



        chartData: {
          columns: ['date', 'PV', 'Order', 'OrderRate'],
          rows: [{
              'date': 'Satılan Bilet Sayısı',
              'PV': 1393,
              'Order': 1093,
              'OrderRate': 0.32
            },
            {
              'date': '1/2',
              'PV': 3530,
              'Order': 3230,
              'OrderRate': 0.26
            },
            {
              'date': '1/3',
              'PV': 2923,
              'Order': 2623,
              'OrderRate': 0.76
            },
            {
              'date': '1/4',
              'PV': 1723,
              'Order': 1423,
              'OrderRate': 0.49
            },
            {
              'date': '1/5',
              'PV': 3792,
              'Order': 3492,
              'OrderRate': 0.323
            },
            {
              'date': '1/6',
              'PV': 10093,
              'Order': 4293,
              'OrderRate': 0.78
            }
          ]
        },

        chartsatis: {
          columns: ['tip', 'İç Hat Satış', 'İç Hat İade', 'Dış Hat Satış', 'Dış Hat İade'],
          rows: [{
              'tip': 'Aralık',
              'İç Hat Satış': 180,
              'İç Hat İade': 18,
              'Dış Hat Satış': 120,
              'Dış Hat İade': 20
            }, {
              'tip': 'Ocak',
              'İç Hat Satış': 150,
              'İç Hat İade': 55,
              'Dış Hat Satış': 110,
              'Dış Hat İade': 40,
            },

          ]
        },

        charthavayolu: {
          columns: ['firma', 'satis', 'iade'],
          rows: [{
            'firma': 'TK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'H9',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'KK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'OHY',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'XQ',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'Diğer',
            'satis': 0,
            'iade': 0
          }]
        },

        colors: ['#03A9F4', '#F44336'],


        chartsatisseklinegore: {

          columns: ['tipi', 'adet'],
          rows: []

        },
      }
    },
    beforeMount: beforeMount,
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getDateNow: getDateNow
    },
    components: {
      tarihcomp,
      VeLine,
      VeBar,
      VePie,
      VeHistogram,
      progressloading
    },
    mounted() {
    }
  }

  function getList() {

    if (this.$refs.formsalesreport.validate()) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.progress = true
      this.SummaryInfo.SirketKodu = credentials.SirketKodu
      var params = this.SummaryInfo
      this.load1 = false
      this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        var yenikayitdizi = []

        // grafik1
        if (response.body.HavayoluAdetList.length > 0) {
          response.body.HavayoluAdetList.forEach(element => {
            var yenikayit = {
              firma: element.HavaYoluKodu,
              satis: element.Adet,
              iade: element.IadeAdet
            }
            yenikayitdizi.push(yenikayit);
          });

          this.charthavayolunagore.rows = yenikayitdizi
        } else {
          var yenikayit = {
            firma: 0,
            satis: 0,
            iade: 0
          }
          yenikayitdizi.push(yenikayit);
          this.charthavayolunagore.rows = yenikayitdizi

        }

        //grafik3
        yenikayitdizi = [];
        
        if (response.body.GunSatisList.length > 0) {

          response.body.GunSatisList.forEach(element => {
            var yenikayit2 = {
              'tarih': element.TarihStr,
              'İç Hat Satış Adet': element.SatisAdetIcHat,
              'İç Hat İade': element.IadeAdetIcHat,
              'Dış Hat Satış Adet': element.SatisAdetDisHat,
              'Dış Hat İade Adet': element.IadeAdetDisHat
            }
            yenikayitdizi.push(yenikayit2);

          });

          this.chartsatistipinegore.rows = yenikayitdizi


        } else {

          
          var yenikayit2 = {
            'tarih': 1,
            'İç Hat Satış Adet': 0,
            'İç Hat İade': 0,
            'Dış Hat Satış Adet': 0,
            'Dış Hat İade Adet': 0
          }
          yenikayitdizi.push(yenikayit2);

          this.chartsatistipinegore.rows = yenikayitdizi
        }

        //grafik2

        yenikayitdizi = [];

        var satistipi = {
          'tipi': 'Kredili',
          'adet': response.body.SatisSekliAdet.KrediliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'R-KK',
          'adet': response.body.SatisSekliAdet.RKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'F-KK',
          'adet': response.body.SatisSekliAdet.FKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'C-KK',
          'adet': response.body.SatisSekliAdet.CKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'P-Peşin',
          'adet': response.body.SatisSekliAdet.PesinAdet
        };
        yenikayitdizi.push(satistipi);
        this.chartsatisseklinegore.rows = yenikayitdizi;
        this.progress = false
        this.load1 = true
        this.satis = response.body.SatisAdet;
        this.iade = response.body.IadeAdet;
        this.voidbilet = response.body.VoidAdet;
        this.toplamsatis = response.body.BiletSatisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamiade = response.body.BiletIadeTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamservis = response.body.SatisServisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamkazanc = response.body.NetKar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.vadesigelenborc = response.body.BorcBilgi.VadesiGecenBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
          '$1,')
        this.toplamborc = response.body.BorcBilgi.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        this.faturaedilmisbilet = response.body.FaturalanmisBiletAdet;
        this.faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
        this.gecicibilet = response.body.GecicideAdet;
        this.kagitfatura = response.body.FaturaTipAdet.KagitFaturaAdet
        this.earsivgonderilen = response.body.FaturaTipAdet.EArsivGonderilenAdet
        this.earsivgonderilmeyen = response.body.FaturaTipAdet.EArsivGonderilmeyenAdet
        this.efaturagonderilen = response.body.FaturaTipAdet.EFaturaGonderilenAdet
        this.efaturagonderilmeyen = response.body.FaturaTipAdet.EFaturaGonderilmeyenAdet

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        }
      })

    }
  }



  function beforeMount() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.PB=credentials.ParaBirimi;

    var yedekcredentials = {
      AnaSirketKodu: credentials.AnaSirketKodu,
      MusteriID: credentials.MusteriID,
      UserID: credentials.UserID,
      ParaBirimi: credentials.ParaBirimi,
      SirketKodu: credentials.SirketKodu,
      SirketAdi: credentials.SirketAdi,
      SirketUnvani: credentials.SirketUnvani,
      Sirketler: credentials.Sirketler,
      EArsiv: credentials.EArsiv,
      EFatura: credentials.EFatura,
      CoperSirketNo: credentials.CoperSirketNo,
      CoperSirketAdi: credentials.CoperSirketAdi,
      CoperSirketUnvan: credentials.CoperSirketUnvan,
      CoperSirketler: credentials.CoperSirketler,
      MuhasebeSirketler: credentials.MuhasebeSirketler,
      MuhasebeSirketNo: credentials.MuhasebeSirketNo,
      MuhasebeSirketAdi: credentials.MuhasebeSirketAdi,
      MuhasebeSirketUnvan: credentials.MuhasebeSirketUnvan
    }


    var sirketparams = {
      SirketKodu: credentials.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MusteriKodu': credentials.AnaSirketKodu.toString()
      }
    }).then((response) => {

      if (response.body.OpsiyonBilgileri != null) {

        yedekcredentials.EArsiv = response.body.OpsiyonBilgileri.EArsiv
        yedekcredentials.EFatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor
      } else {
        yedekcredentials.EArsiv = 0
        yedekcredentials.EFatura = 0
      }


      window.localStorage.setItem('credentials', JSON.stringify(yedekcredentials));


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      } else {

        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

      }
    })



    //ilk girişte verileri çekelim

    this.SummaryInfo.BaslangicTarihi = getDateNow();
    this.SummaryInfo.BitisTarihi = getDateNow();


    this.progress = true
    this.SummaryInfo.SirketKodu = credentials.SirketKodu
    var params = this.SummaryInfo
    this.load1 = false
    this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      var yenikayitdizi = []

      // grafik1
      if (response.body.HavayoluAdetList.length > 0) {
        response.body.HavayoluAdetList.forEach(element => {
          var yenikayit = {
            firma: element.HavaYoluKodu,
            satis: element.Adet,
            iade: 0
          }
          yenikayitdizi.push(yenikayit);
        });

        this.charthavayolunagore.rows = yenikayitdizi
      } else {
        var yenikayit = {
          firma: 0,
          satis: 0,
          iade: 0
        }
        yenikayitdizi.push(yenikayit);
        this.charthavayolunagore.rows = yenikayitdizi

      }

      //grafik3
      yenikayitdizi = [];

      if (response.body.GunSatisList.length > 0) {
        response.body.GunSatisList.forEach(element => {
          var yenikayit2 = {
            'tarih': element.TarihStr,
            'İç Hat Satış Adet': element.SatisAdetIcHat,
            'İç Hat İade': element.IadeAdetIcHat,
            'Dış Hat Satış Adet': element.SatisAdetDisHat,
            'Dış Hat İade Adet': element.IadeAdetDisHat
          }
          yenikayitdizi.push(yenikayit2);

        });

        this.chartsatistipinegore.rows = yenikayitdizi
      } else {

        var yenikayit2 = {
          'tarih': 0,
          'İç Hat Satış Adet': 0,
          'İç Hat İade': 0,
          'Dış Hat Satış Adet': 0,
          'Dış Hat İade Adet': 0
        }
        yenikayitdizi.push(yenikayit2);
        this.chartsatistipinegore.rows = yenikayitdizi
      }


      //grafik2

      yenikayitdizi = [];

      var satistipi = {
        'tipi': 'Kredili',
        'adet': response.body.SatisSekliAdet.KrediliAdet
      };
      yenikayitdizi.push(satistipi);

      satistipi = {
        'tipi': 'R-KK',
        'adet': response.body.SatisSekliAdet.RKartliAdet
      };
      yenikayitdizi.push(satistipi);

      satistipi = {
        'tipi': 'F-KK',
        'adet': response.body.SatisSekliAdet.FKartliAdet
      };
      yenikayitdizi.push(satistipi);

      satistipi = {
        'tipi': 'C-KK',
        'adet': response.body.SatisSekliAdet.CKartliAdet
      };
      yenikayitdizi.push(satistipi);

      this.chartsatisseklinegore.rows = yenikayitdizi;

      this.progress = false
      this.load1 = true

      this.satis = response.body.SatisAdet;
      this.iade = response.body.IadeAdet;
      this.voidbilet = response.body.VoidAdet;
      this.toplamsatis = response.body.BiletSatisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      this.toplamiade = response.body.BiletIadeTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      this.toplamservis = response.body.SatisServisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      this.toplamkazanc = response.body.NetKar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      this.vadesigelenborc = response.body.BorcBilgi.VadesiGecenBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
        '$1,')
      this.toplamborc = response.body.BorcBilgi.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      this.faturaedilmisbilet = response.body.FaturalanmisBiletAdet;
      this.faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
      this.gecicibilet = response.body.GecicideAdet;
      this.kagitfatura = response.body.FaturaTipAdet.KagitFaturaAdet
      this.earsivgonderilen = response.body.FaturaTipAdet.EArsivGonderilenAdet
      this.earsivgonderilmeyen = response.body.FaturaTipAdet.EArsivGonderilmeyenAdet
      this.efaturagonderilen = response.body.FaturaTipAdet.EFaturaGonderilenAdet
      this.efaturagonderilmeyen = response.body.FaturaTipAdet.EFaturaGonderilmeyenAdet
     // this.progressloading=false


    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false
      }
    })









  }

  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>